<style lang="scss" scoped>
// .sp-table-grid {
//   .bd {
//     .el-table {
//       border-width: 0;
//     }
//     thead {
//       th {
//         background: #f2f2f2;
//         font-weight: normal;
//         padding: 4px 10px;
//         font-size: 13px;
//         height: 36px;
//         border-right: 1px solid $color-border-gray-light;
//         border-top: 1px solid $color-border-gray-light;
//         box-sizing: content-box;
//         border-bottom-width: 0;
//         &:first-child {
//           border-left: 1px solid $color-border-gray-light;
//         }
//       }
//     }

tbody {
  th {
    border: none !important;
    border-bottom: 1px solid #ebeef5 !important;
  }
  td {
    padding: 4px 10px;
    font-size: 13px;
    height: 36px;
    // border-right: 1px solid $color-border-gray-light;
    // border-top: 1px solid $color-border-gray-light;
    box-sizing: content-box;
    border-bottom-width: 0;
    border: none !important;
    border-bottom: 1px solid #ebeef5 !important;
    // border-left:none !important;
    img {
      width: 60px;
      height: 60px;
    }
  }
  tr {
    border-left: none !important;
    // th {
    //   border: none !important;
    //   border-bottom: 1px solid #EBEEF5 !important;
    // }
    td {
      &:first-child {
        border-left: none;
      }
    }
    &:last-child {
      td {
        border-bottom: 1px solid $color-border-gray-light;
      }
    }
  }
}
// }
.ft {
  padding: 10px 0;
  text-align: right;
}
.el-table__empty-block {
  border-left: 1px solid $color-border-gray-light;
}
// }
</style>

<script>
/**
 * @author lkj
 * @description 表格网：
 * @see The https://ba-uat.shopex123.com/customer/statistics @view/customer/statistics.vue
 * @since version 1.0
 * @returns {Array}
 * @param {Array} columns 列字段
 * @param {Number} pageSize 页数据量
 * @param {Boolean} nopagination 是否展示分页
 * @param {Function} onPageChange 分页事件会调
 */
export default {
  name: 'SpTableGrid',
  props: {
    columns: Array,
    pageSize: {
      type: Number,
      default: 10
    },
    // dataSource: Array,
    // total: Number,
    nopagination: Boolean,
    onPageChange: Function
  },
  data () {
    return {
      pageCur: 1,
      // size: this.pageSize,
      pageCount: -1,
      list: [],
      total: 0
    }
  },
  computed: {
    // pageTotal () {
    //   if (this.pageCount < 0) return 0
    //   const total = Math.ceil(this.pageCount / this.pageSize)
    //   return total
    // }
  },
  created () {
    this.onCurrentChange(this.pageCur)
  },
  methods: {
    fetch () {
      this.pageCur = 1
      this.total = 0
      this.onCurrentChange(this.pageCur)
    },
    async onCurrentChange (page) {
      const { list, total_count } = await this.onPageChange({
        page,
        pageSize: this.pageSize
      })

      this.list = list
      this.total = total_count
    }
  },
  render (h) {
    const { list, columns, nopagination, pageCur, pageSize, total, onCurrentChange } = this
    // console.log('list',list)
    const renderTableColumns = (columns, idx) => {
      return columns.map((col, idx) => {
        const { formatter } = col
        const props = {
          props: {
            formatter
          }
        }
        if (col.render) {
          props.scopedSlots = {
            ...props.scopedSlots,
            default: (scope) => col.render(h, scope)
          }
        }
        return (
          <el-table-column
            label={col.name}
            type={col.type || null}
            prop={col.key}
            key={idx}
            show-overflow-tooltip
            {...props}
          ></el-table-column>
        )
      })
    }

    return (
      <div class='sp-table-grid'>
        <div class='bd'>
          <el-table border style='width: 100%' data={list}>
            {renderTableColumns(columns)}
          </el-table>
        </div>

        {!nopagination && (
          <div class='ft'>
            <el-pagination
              background
              layout='prev, pager, next'
              current-page={pageCur}
              page-size={pageSize}
              total={total}
              {...{
                on: {
                  'current-change': onCurrentChange
                }
              }}
            ></el-pagination>
          </div>
        )}
      </div>
    )
  }
}
</script>
